import {SharedInputEdit} from '../../components/SharedInputEdit';
import {useContext} from 'react';
import {CalculatorAdvancedModeContext, CalculatorHtmModeContext} from '../../../../shared/contexts/CalculatorContext';
import {CalculatorAdvancedMode, CalculatorHTMMode} from '../../../../shared/classes/CalculatorMode';

export function WorkforceInput(): JSX.Element {
    const advancedMode = useContext(CalculatorAdvancedModeContext)!;
    const [isHTM] = useContext(CalculatorHtmModeContext)!
    const htm = isHTM === CalculatorHTMMode.HTM;

    return (
        <div className="workforce --ctow">

            <div>

                <div>

                    <h4>Data Inputs from Nuclear Department {htm ? 'HTM': 'no'}</h4>

                    <SharedInputEdit inputName='number_of_nuclearists_clinicians'/>
                    <SharedInputEdit inputName='number_of_technologists'/>
                    <SharedInputEdit inputName='technologist_wages_per_hour'/>
                    <SharedInputEdit inputName='radiologist_nuclearist_wages_per_hour'/>

                    <SharedInputEdit inputName='technologist_overtime_wages_in_percent'/>
                    <SharedInputEdit inputName='radiologist_nuclearist_overtime_wages_in_percent'/>

                </div>

                {
                    advancedMode[0] === CalculatorAdvancedMode.Advanced
                        ? <div>

                            <h4>Data Inputs for Hospital Workflow</h4>

                            <SharedInputEdit inputName='of_doctor_s_clinician_s'/>
                            <SharedInputEdit inputName='doctor_clinician_wages_per_hours'/>
                            <SharedInputEdit inputName='of_nurses'/>
                            <SharedInputEdit inputName='nurses_wages_per_hour'/>


                            {htm
                                ? <>
                                    <h4>Data Inputs for HTM's Organization</h4>
                                    <SharedInputEdit inputName='in_house_engineer_cost_per_hour'/>
                                </>
                                : ''}
                        </div>

                        : ''
                }


            </div>

        </div>

    );
}
